import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import { AddServiceImageAdd } from "../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";

export default function ServiceImageAdd({
  serviceAdd,
  serviceInfoId,
  setServiceAdd,
}) {
  const [mainPhoto, setMainPhoto] = useState("");
  const [photoFile, setPhotoFile] = useState();
  const [details, setDetails] = useState("");
  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setMainPhoto(reader.result);
    };
    setPhotoFile(file);
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const saveNewServiceImageAdd = () => {
    dispatch(AddServiceImageAdd({ details, photoFile, id: serviceInfoId }));
    setMainPhoto("");
    setDetails("");
    toast.info("Adding Service Image...", { autoClose: false });
    setServiceAdd(false);
  };
  return (
    serviceAdd && (
      <div className="service-images-add-action" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setServiceAdd(false)}
        ></div>
        <div className="container ">
          <div className="title">اضافه صوره جديده</div>
          <label
            htmlFor="add-image"
            className={mainPhoto ? `image` : `image none`}
          >
            <img src={mainPhoto ? `${mainPhoto}` : `/images/add.png`} alt="" />
          </label>
          <input
            type="file"
            onChange={handleFileChange}
            name=""
            accept="image/*"
            id="add-image"
            style={{ display: "none" }}
          />
          <div className="text">
            <textarea
              type="text"
              placeholder="Details Of Image"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
            />
          </div>
          <div className="add-btn" onClick={() => saveNewServiceImageAdd()}>
            اضافه
          </div>
        </div>
      </div>
    )
  );
}
